import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {
  Link,
  Button,
  Flex, FormControl, FormErrorMessage, FormLabel,
  Grid, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spacer, Text,
  useColorModeValue, useDisclosure
} from "@chakra-ui/react";
import axios from "axios";
import {useAuthHeader} from "react-auth-kit";
import BgCharged from "../assets/img/BgCharged.png";
import netting from "../assets/img/avatars/netting.png";
import forta from "../assets/img/avatars/forta.png";
import {FaBackspace} from "react-icons/fa";
import Header from "../components/Header";
import LongParams from "../components/LongParams";
import TransactionInfo from "../components/Tables/components/TransactionInfo";
import TransactionInfoJson from "../components/Tables/components/TransactionInfoJson";
import {useForm} from "react-hook-form";

export function TransactionDetails(getAction) {
  const bgProfile = useColorModeValue(
    "hsla(0,0%,100%,.8)",
    "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
  );
  const { id } = useParams();
  const token = useAuthHeader();
  const [action, setAction] = useState(false)
  const [partner, setPartner] = useState('')
  const [notObjectResult, setNotObjectResult] = useState([])
  const [objectResult, setObjectResult] = useState([])
  const [long, setLong] = useState([])
  const navigate = useNavigate();
  const [longVault, setLongVault] = useState([])

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [vaultResponse, setVaultResponse] = useState('')
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm()

  useEffect(() => {
    setAction(getAction)
  },[getAction])

  useEffect(() => {
    if (action){
      let active = true
      const getResult = async () => {
        if (active) {
          const result = await fetchData(id, token());

          let data = Object.values(result)
          let keys = Object.keys(result)

          let obj = []
          let notObj = {}
          let long = {}
          let longVault = {}
          for (let i = 0; i < data.length; ++i)
          {
            if (typeof data[i] === 'object') {
              if (data[i] !== null) {
                obj[keys[i]] = data[i]
              } else {
                notObj[keys[i]] = data[i]
              }
            } else {
              if (keys[i] === 'secured_box') {
                long[keys[i]] = data[i]
              } else if (keys[i] === 'secured_box_vault') {
                longVault[keys[i]] = data[i]
              } else {
                notObj[keys[i]] = data[i]
              }
            }
          }
          // console.log('obj keys = ', Object.keys(obj))

          setObjectResult(obj)
          setNotObjectResult(notObj)
          setLong(long)
          setLongVault(longVault)

          return () => {
            active = false;
          };
        }
      }
      getResult().then();
      return () => {
        active = false;
      };
    }
  },[action])

  useEffect(() => {
    if (action){
      let active = true
      const getPartner = async () => {
        if (active) {
          const merchant = await fetchPartner(notObjectResult.merchant, token());

          setPartner(merchant)
          return () => {
            active = false;
          };
        }
      }
      getPartner().then();
      return () => {
        active = false;
      };
    }
  },[notObjectResult.id])

  async function onSubmit(value) {
    try {
      const newData = await vaultDescript(token(), value['pass'], longVault['secured_box_vault']);
      setVaultResponse(newData)
      onClose()
    } catch (e) {
      return new Promise((resolve) => {
        setTimeout(() => {
          alert(JSON.stringify(e.response.data, null, 2))
          resolve()
        }, 1000)
      })
    }
  }

  return (
    <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
      <Header
        BackUrl={'/admin_area/transactions'}
        backgroundHeader={BgCharged}
        backgroundProfile={bgProfile}
        avatarImage={notObjectResult.merchant === 15 ? forta : netting}
        name={partner.name}
        email={[ partner.login, '  (',
          notObjectResult.merchant, ')'
        ]}
        tabs={[
          {
            name: "Back",
            icon: <FaBackspace w='100%' h='100%' />,
          }
        ]}
      />
      <Text align='right' mb={'10px'}>
        <Link color='teal.500' onClick={() => {navigate(`/admin_area/transactions/audit_log/${id}`, {replace: true})}} >
          Смотреть audit log
        </Link>
      </Text>
      <Grid templateColumns={{ sm: "1fr", xl: "repeat(1, 1fr)" }} gap='22px'>

        {notObjectResult &&
          <TransactionInfo
            title={"info"}
            value={notObjectResult}
          />
        }

        {objectResult && (
          Object.keys(objectResult).map( (value, id) => {
            return (
              <TransactionInfoJson
                key={id}
                title={`${value}`}
                value={objectResult[value]}
              />
            )
          }))
        }
        {long && (
          Object.keys(long).map( (value, id) => {
            return (
              <LongParams key={id}
                          title={`${value}`}
                          params={<pre-wrap>{JSON.stringify(long[value], null, 2)}</pre-wrap>}
              />
            )
          }))
        }
        {longVault && (
          Object.keys(longVault).map( (value, id) => {
            return (
              <form>
                <LongParams key={id}
                            title={`${value}`}
                            params={<pre-wrap>{JSON.stringify(longVault[value], null, 2)}</pre-wrap>}
                />
                <Button mt={4} colorScheme='teal' onClick={onOpen}>Расшифровать данные</Button>
              </form>
            )
          }))
        }
        {vaultResponse && <pre>{JSON.stringify(vaultResponse, null, 2)}</pre>}
      </Grid>
      <Modal autoFocus={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Расшифровка данных</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalBody>
              <FormControl isInvalid={errors.name}>
                <Text mb={4} borderRadius={1} fontSize='sm'>{longVault['secured_box_vault']}</Text>
                <FormLabel htmlFor='name'>Введите пароль</FormLabel>
                <Input
                  autoFocus
                  id='pass'
                  placeholder='Type vault pass...'
                  {...register('pass', {
                    required: 'This is required',
                    minLength: { value: 1, message: 'Minimum length should be 1' },
                  })}
                />
                <FormErrorMessage>
                  {errors.name && errors.name.message}
                </FormErrorMessage>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button mt={4} colorScheme='blue' isLoading={isSubmitting} type='submit'>Отправить</Button>
              <Spacer/>
              <Button mt={4} colorScheme='red' onClick={onClose}>Закрыть</Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </Flex>
  );

  async function fetchData(id = 'e0abb45a-2383-46ef-922f-ddc7e9b010a2', token) {
    const response = await axios.get(`/api/v1/transactions/${id}`,
      {headers: {Authorization: token}})
    return await response.data
  }

  async function fetchPartner(partnerId = 1, token) {
    const response = await axios.get(`/api/v1/profile?id=${partnerId}`,
      {headers: {Authorization: token}})
    return await response.data
  }

  async function vaultDescript(token, pass, value) {
    try {
      let raw = {
        "data": value
      };

      let error = {
        "errors": [
          {
            "detail": "Неверный пароль: " + pass
          }
        ]
      };

      if (pass === '123') {
        const response = await axios.post(`/api/v1/encryption/_decrypt`, raw,
          {headers: {Authorization: token}})
        return await response.data
      }
      return error

    } catch (e) {
      return e.response
    }
  }
}
